package one.healthium.today.ui.components

import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.width
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.domain.user.models.UserProfileModel
import one.healthium.profile.ui.avatar.UserAvatar
import one.healthium.ui.compose.theme.AppTheme
import one.healthium.ui.effect.greetingMessage
import androidx.compose.ui.tooling.preview.Preview

@Composable
fun TodayUserProfile(
    modifier: Modifier = Modifier,
    userProfile: UserProfileModel,
) {
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        UserAvatar(size = 50.dp)
        Spacer(Modifier.width(16.dp))
        UserName(modifier = Modifier.weight(1f), userProfile = userProfile)
    }
}

@Composable
private fun UserName(
    modifier: Modifier = Modifier,
    userProfile: UserProfileModel,
) {
    Text(
        modifier = modifier,
        text = "${userProfile.name.orEmpty()},\n${greetingMessage(true)}",
        style = AppTheme.textStyles.secondary_20_700,
        color = LocalContentColor.current,
        maxLines = 2,
    )
}

@Preview
@Composable
private fun TodayUserProfilePreview() {
    AppTheme {
        TodayUserProfile(
            userProfile = UserProfileModel.preview,
        )
    }
}
